import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '615px',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  padding: '80px 24px',
  width: '100%',
  backgroundColor: '#0f172a', // slate-900
  [theme.breakpoints.up('md')]: {
    padding: '128px 48px'
  },
  [theme.breakpoints.up('lg')]: {
    padding: '128px 64px'
  },
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto'
  }
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '1200px',
  alignItems: 'center',
  gap: '40px',
  [theme.breakpoints.down('sm')]: {
    gap: '30px'
  }
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  gap: '6px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontWeight: 800,
  fontSize: '46px',
  textAlign: 'center',
  letterSpacing: '-0.025em',
  lineHeight: 1.2,
  '& .black': {
    color: '#ffffff'
  },
  '& .blue': {
    background: 'linear-gradient(90deg, #22d3ee, #a5b4fc)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px'
  }
}));

const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: '18px',
  color: '#94a3b8', // slate-400
  textAlign: 'center',
  letterSpacing: '0',
  lineHeight: 1.6,
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px'
  }
}));

const CardsContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: '341px',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto'
  }
}));

const CardsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: '20px',
  width: '100%',
  maxWidth: '1100px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

const ReviewCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '493px',
  minHeight: '341px',
  alignItems: 'center',
  gap: '10px',
  padding: '28px 23px',
  backgroundColor: '#1e293b', // slate-800
  borderRadius: '12px',
  border: '1px solid #334155', // slate-700
  [theme.breakpoints.down('sm')]: {
    padding: '20px 16px',
    minHeight: 'auto'
  }
}));

const ResultsCard = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  maxWidth: '566px',
  minHeight: '341px',
  backgroundColor: '#1e293b', // slate-800
  borderRadius: '12px',
  border: '1px solid #334155', // slate-700
  padding: '26px 28px',
  [theme.breakpoints.down('sm')]: {
    padding: '20px 16px',
    minHeight: 'auto'
  }
}));

const StatCard = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '92px',
  backgroundColor: '#0f172a', // slate-900
  borderRadius: '8px',
  border: '1px solid #334155',
  boxShadow: '0 0 15px rgba(34, 211, 238, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '10px',
  padding: '10px 13px',
  [theme.breakpoints.down('sm')]: {
    minHeight: '80px',
    padding: '8px 10px'
  }
}));

const ArrowButton = styled('img')(({ theme, position }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  left: position === 'left' ? '10px' : 'auto',
  right: position === 'right' ? '10px' : 'auto',
  width: '40px',
  height: '40px',
  cursor: 'pointer',
  zIndex: 10,
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));

const Pagination = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  marginTop: '20px'
}));

const PaginationDot = styled(Box)(({ theme, active }) => ({
  width: active ? '23px' : '8px',
  height: '8px',
  backgroundColor: active ? '#0B91D6' : '#D9D9D9',
  borderRadius: active ? '12px' : '4px'
}));

const MeasurableResultsSection = () => {
  const [activeReviewIndex, setActiveReviewIndex] = React.useState(0);

  const reviews = [
    {
      name: 'Dharmender kumar Gupta',
      designation: '',
      avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjVnhdKi_3fqCFR78cjgo0iIGlcEx2jjEZsKXACs9GDJQFI0iFz5=w40-h40-c-rp-mo-br100',
      text: 'We are very impressed with the service of E2E Digitech ... Team is very professional .... Keep the good work ... Highly recommended...'
    },
    {
      name: 'Ashu',
      designation: 'Bike Dealer',
      avatar: 'https://c.animaapp.com/mgbvruh0ta8bZ7/img/ellipse-86-2.png',
      text: "Thank you team for handling my profile from day one to now it's the same and good response and I use to get daily business calls. They also keep posting content on profile. Anyone looking digital marketing company must check team e2e once."
    }
  ];

  const handleNext = () => {
    setActiveReviewIndex((prev) => (prev + 1) % reviews.length);
  };

  const handlePrev = () => {
    setActiveReviewIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const currentReview = reviews[activeReviewIndex];

  return (
    <SectionContainer>
      <ContentWrapper>
        <SectionHeader>
          <SectionTitle>
            <span className="black">Customer </span>
            <span className="blue">Review</span>
          </SectionTitle>
          <SectionSubtitle>
            Climb to the top of local search results and stay ahead of competitors.
          </SectionSubtitle>
        </SectionHeader>

        <CardsContainer>
          <CardsWrapper>
            <ReviewCard>
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '104px', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
                <img
                  style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                  alt={currentReview.name}
                  src={currentReview.avatar}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', width: '100%' }}>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '16px', color: '#ffffff', textAlign: 'center', marginTop: '-1px' }}>
                    {currentReview.name}
                  </Typography>
                  {currentReview.designation && (
                    <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontStyle: 'italic', fontSize: '12px', color: '#94a3b8', textAlign: 'center' }}>
                      {currentReview.designation}
                    </Typography>
                  )}
                  <Box sx={{ position: 'relative', width: '99.93px', height: '16px' }}>
                    {[0, 21, 41, 62, 82].map((left, index) => (
                      <Typography key={index} sx={{ position: 'absolute', top: 0, left: `${left}px`, width: '18px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Font Awesome 5 Free-Solid, Helvetica', fontWeight: 400, color: '#FBBC05', fontSize: '15.5px' }}>
                        ★
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </Box>
              <Typography sx={{
                width: '100%',
                maxWidth: '384px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '13px', sm: '14px' },
                color: '#94a3b8',
                textAlign: 'center',
                lineHeight: '24px'
              }}>
                {currentReview.text}
              </Typography>
            </ReviewCard>

            <ResultsCard>
              <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: { xs: '16px', sm: '18px' }, color: '#ffffff', marginBottom: '20px' }}>
                Measurable Result
              </Typography>

              <Box sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                gap: '20px',
                width: '100%'
              }}>
                <StatCard>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '16px', color: '#ffffff', lineHeight: '24px' }}>
                    Search Ranking
                  </Typography>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '24px' }}>
                    <span style={{ fontWeight: 500, color: '#FBBC05' }}>From </span>
                    <span style={{ fontWeight: 600, color: '#FBBC05', fontSize: '20px' }}>#20</span>
                    <span style={{ fontWeight: 500, color: '#FBBC05' }}> to </span>
                    <span style={{ fontWeight: 600, color: '#FBBC05', fontSize: '20px' }}>#02</span>
                  </Typography>
                </StatCard>

                <StatCard>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '16px', color: '#ffffff', lineHeight: '24px' }}>
                    Customer Review
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '18px', color: '#0B91D6', lineHeight: '24px' }}>
                      4.5
                    </Typography>
                    <img style={{ width: '20px', height: '20px' }} alt="Star" src="https://c.animaapp.com/mgbvruh0ta8bZ7/img/star-17.svg" />
                    <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '18px', color: '#0B91D6', lineHeight: '24px' }}>
                      across all platform
                    </Typography>
                  </Box>
                </StatCard>

                <StatCard>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '16px', color: '#ffffff', lineHeight: '24px' }}>
                    Business Growth
                  </Typography>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '18px', color: '#34A853', lineHeight: '24px' }}>
                    +73% foot traffic
                  </Typography>
                </StatCard>

                <StatCard>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '16px', color: '#ffffff', lineHeight: '24px' }}>
                    Time to result
                  </Typography>
                  <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: '18px', color: '#EF232A', lineHeight: '24px' }}>
                    20 to 40 days
                  </Typography>
                </StatCard>
              </Box>
            </ResultsCard>
          </CardsWrapper>

          <ArrowButton
            position="left"
            src="https://c.animaapp.com/mgbvruh0ta8bZ7/img/frame-1000005320.svg"
            alt="Previous"
            onClick={handlePrev}
          />
          <ArrowButton
            position="right"
            src="https://c.animaapp.com/mgbvruh0ta8bZ7/img/frame-1000005409.svg"
            alt="Next"
            onClick={handleNext}
          />
        </CardsContainer>

        <Pagination>
          {reviews.map((_, index) => (
            <PaginationDot
              key={index}
              active={index === activeReviewIndex}
            />
          ))}
        </Pagination>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default MeasurableResultsSection;
